import React, { createContext, useEffect, useMemo, useState } from 'react'
import MainLayout from '../../components/MainLayout';
import { Grid } from 'antd';
const { useBreakpoint } = Grid;
import { ApiServices } from '../../services/apiServices';
import { ApiConfig, driversListUrl } from '../../services/ApiConfigs';
import DashboardCards from './DashboardCards';
import moment from 'moment';
import store from '../../redux/store';
import { Avatar, Card, Space, Table, Tag, Row, Col, Statistic } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import CountUp from "react-countup";

export const HomeContext = createContext({})

const Dashboard = () => {
  const screens = useBreakpoint();
  const isMobile = !screens.md;

  const [asignDriverModalOpen, setAsignDriverModalOpen] = useState(false);
  const [multipleModalOpen, setMultipleModalOpen] = useState(false);
  const [wareHouseData, setWarehouseData] = useState([]);
  const [driverData, setDriverData] = useState([])
  const [orderData, setOrdersData] = useState([])
  const [assignTableData, setAssignTableData] = useState([])
  const [assignOrderData, setAssignOrderData] = useState([])
  const [loader, setLoader] = useState(false)
  const [selectedOrder, setSelectedOrder] = useState({});
  const [activeButton, setActiveButton] = useState('all_orders');

  // Get user data from Redux store
  const userData = store.getState()?.UserData?.userData || {};

  // const { data: Orders, error, loading, refetch } = useFetch(ApiConfig.Orders, { trigger: true, });

  // console.log(Orders, "Orders");
  // console.log(error, "error");

  useEffect(() => {
    getWarehouse()
    getDrivers()
    getOrders()
  }, [])

  // useEffect(() => setOrdersData(Orders), [Orders])

  const getOrders = async () => {
    try {
      const storeId = userData?.store_id || userData?.user?.storeId;
      if (!storeId) {
        setOrdersData([]);
        return;
      }
      const res = await ApiServices('get', ApiConfig.getallOrderByStoreId + "/" + storeId);
      const tmp = res?.data || [];
      setOrdersData(Array.isArray(tmp) ? tmp : []);
    } catch (error) {
      console.error('Error fetching orders:', error);
      setOrdersData([]);
    }
  }

  const getDrivers = async () => {
    try {
      const sid = userData?.store_id || userData?.user?.storeId;
      await ApiServices('get', driversListUrl(sid)).then((res) => {
        let tmp = res?.data || [];
        console.log(tmp, "getDrivers response..")
        if (res.status == 200) {
          setDriverData(Array.isArray(tmp) ? tmp : [])
        } else {
          setDriverData([])
        }
      }).catch((error) => {
        console.error('Error fetching drivers:', error);
        setDriverData([]);
      })
    } catch (error) {
      console.error('Error in getDrivers:', error);
      setDriverData([]);
    }
  }

  const getAssignOrders = async () => {
    getOrders();
  }

  const getWarehouse = async () => {
    try {
      const res = await ApiServices('get', ApiConfig.WAREHOUSE);
      console.log(res, "get warehouser")
      setWarehouseData(res?.data || [])
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    if (Array.isArray(orderData) && orderData.length > 0) {
      const finderData = orderData.map((order) => ({
        ...order,
        node: {
          ...order,
          driverId: (order.shipments || [])[0]?.driverId,
          driver: (order.shipments || [])[0]?.driver,
          pickupWarehouseId: (order.shipments || [])[0]?.pickupWarehouseId,
          completedAt: (order.shipments || [])[0]?.deliveredAt,
        }
      }));
      setAssignTableData(finderData);
      setAssignOrderData(orderData);
    } else {
      setAssignTableData([]);
      setAssignOrderData([]);
    }
  }, [orderData]);

  const submitAsignDriver = () => {
    console.log("ok submitAsignDriver")
  }

  const [selectedRowKeys, setSelectedRowKeys] = useState([]);

  const passData = {
    asignDriverModalOpen,
    setAsignDriverModalOpen,
    submitAsignDriver,
    wareHouseData,
    driverData,
    selectedOrder,
    activeButton,
    setActiveButton,
    getAssignOrders,
    multipleModalOpen, setMultipleModalOpen,
    awaitingOrders: Array.isArray(assignTableData) ? assignTableData.filter((at) => at && at.node && !at.node.driverId) : [],
    selectedRowKeys,
    setSelectedRowKeys
  }

  const handleTableData = (data) => {
    if (activeButton == "all_orders") {
      return data
    } else if (activeButton == "today_orders") {
      const today = new Date().toISOString().split("T")[0];
      return data.filter(order => {
        const orderDate = new Date(order.createdAt).toISOString().split("T")[0];
        return orderDate === today;
      });
    } else if (activeButton == "assign_orders") {
      const tmp = data.filter((item) => item.node?.driverId && !item.node.cancelNote)
      return tmp
    } else if (activeButton == "complete_orders") {
      const tmp = data.filter((item) => item.node?.driverId && item.node.completedAt)
      return tmp
    } else if (activeButton == "cancel_orders") {
      const tmp = data.filter((item) => item.node?.driverId && item.node.cancelNote != null)
      return tmp
    } else {
      return []
    }
  }


  const onSelectChange = (newSelectedRowKeys) => {
    console.log('Selected Row Keys:', newSelectedRowKeys);
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const driverReportRows = useMemo(() => {
    const drivers = Array.isArray(driverData) ? driverData : [];
    const orders = Array.isArray(orderData) ? orderData : [];

    // Build shipment list from orders
    const shipments = [];
    for (const o of orders) {
      const list = o?.shipments || [];
      for (const s of list) {
        if (!s) continue;
        shipments.push({ ...s, __orderId: o?.id, __orderNumber: o?.orderId });
      }
    }

    const byDriver = new Map();
    for (const d of drivers) {
      if (!d?.id) continue;
      byDriver.set(Number(d.id), {
        key: d.id,
        id: d.id,
        name: `${d.firstName || ''} ${d.lastName || ''}`.trim() || `Driver ${d.id}`,
        phone: d.phone || '',
        email: d.email || '',
        isAvailable: d.isAvailable || 'Offline',
        photoUrl: d?.photoData?.url || null,
        activeShipments: 0,
        totalAssigned: 0,
        completed: 0,
      });
    }

    for (const s of shipments) {
      const driverId = s?.driverId;
      if (!driverId) continue;
      const row = byDriver.get(Number(driverId));
      if (!row) continue;
      row.totalAssigned += 1;
      const st = String(s?.shipmentStatus || '').toUpperCase();
      const delivered = st === 'DELIVERED' || st === 'COMPLETED';
      if (delivered) row.completed += 1;
      else row.activeShipments += 1;
    }

    return Array.from(byDriver.values()).sort((a, b) => {
      // Active first, then online, then name
      if (b.activeShipments !== a.activeShipments) return b.activeShipments - a.activeShipments;
      const aOn = a.isAvailable === 'Online';
      const bOn = b.isAvailable === 'Online';
      if (aOn !== bOn) return aOn ? 1 : -1;
      return a.name.localeCompare(b.name);
    });
  }, [driverData, orderData]);

  const driverReportColumns = useMemo(() => ([
    {
      title: 'Driver',
      key: 'driver',
      render: (_, record) => (
        <Space>
          <Avatar
            size="small"
            src={record.photoUrl || undefined}
            icon={<UserOutlined />}
            style={{ backgroundColor: '#1677ff' }}
          />
          <div style={{ lineHeight: 1.2 }}>
            <div style={{ fontWeight: 700 }}>{record.name}</div>
            {record.phone ? <div style={{ fontSize: 11, color: '#8c8c8c' }}>{record.phone}</div> : null}
          </div>
        </Space>
      ),
    },
    {
      title: 'Status',
      dataIndex: 'isAvailable',
      key: 'isAvailable',
      width: 110,
      render: (v) => (
        <Tag color={v === 'Online' ? 'green' : 'default'}>
          {v === 'Online' ? 'Online' : 'Offline'}
        </Tag>
      ),
    },
    {
      title: 'Active',
      dataIndex: 'activeShipments',
      key: 'activeShipments',
      width: 90,
      render: (v) => <Tag color={v > 0 ? 'blue' : 'default'}>{v}</Tag>,
    },
    {
      title: 'Assigned',
      dataIndex: 'totalAssigned',
      key: 'totalAssigned',
      width: 95,
    },
    {
      title: 'Completed',
      dataIndex: 'completed',
      key: 'completed',
      width: 100,
    },
  ]), []);

  const todayDriverPaymentRows = useMemo(() => {
    const drivers = Array.isArray(driverData) ? driverData : [];
    const orders = Array.isArray(orderData) ? orderData : [];
    const today = moment().format("YYYY-MM-DD");

    const byDriver = new Map();
    for (const d of drivers) {
      if (!d?.id) continue;
      byDriver.set(Number(d.id), {
        key: d.id,
        driverId: d.id,
        name: `${d.firstName || ''} ${d.lastName || ''}`.trim() || `Driver ${d.id}`,
        photoUrl: d?.photoData?.url || null,
        codCount: 0,
        codAmount: 0,
        directCount: 0,
        directAmount: 0,
        totalCount: 0,
        totalAmount: 0,
      });
    }

    for (const o of orders) {
      const paymentType = String(o?.paymentType || 'COD').toUpperCase();
      const amount = Number(o?.amount || 0);
      const shipments = Array.isArray(o?.shipments) ? o.shipments : [];
      for (const s of shipments) {
        if (!s?.driverId) continue;
        const assignedAt = s.assignedAt || o.createdAt;
        if (!assignedAt) continue;
        const d = moment(assignedAt).format("YYYY-MM-DD");
        if (d !== today) continue;

        const row = byDriver.get(Number(s.driverId));
        if (!row) continue;
        const isCOD = paymentType === 'COD';
        if (isCOD) {
          row.codCount += 1;
          row.codAmount += amount;
        } else {
          row.directCount += 1;
          row.directAmount += amount;
        }
        row.totalCount += 1;
        row.totalAmount += amount;
      }
    }

    return Array.from(byDriver.values())
      .filter((r) => r.totalCount > 0)
      .sort((a, b) => b.totalAmount - a.totalAmount);
  }, [driverData, orderData]);

  const todayDriverPaymentTotals = useMemo(() => {
    return todayDriverPaymentRows.reduce((acc, r) => {
      acc.codCount += r.codCount;
      acc.codAmount += r.codAmount;
      acc.directCount += r.directCount;
      acc.directAmount += r.directAmount;
      acc.totalCount += r.totalCount;
      acc.totalAmount += r.totalAmount;
      return acc;
    }, { codCount: 0, codAmount: 0, directCount: 0, directAmount: 0, totalCount: 0, totalAmount: 0 });
  }, [todayDriverPaymentRows]);

  const formatter = (value) => <CountUp end={Number(value || 0)} duration={1.1} separator="," />;

  const todayDriverPaymentColumns = useMemo(() => ([
    {
      title: 'Driver',
      key: 'driver',
      render: (_, record) => (
        <Space>
          <Avatar
            size="small"
            src={record.photoUrl || undefined}
            icon={<UserOutlined />}
            style={{ backgroundColor: '#1677ff' }}
          />
          <span style={{ fontWeight: 700 }}>{record.name}</span>
        </Space>
      ),
    },
    {
      title: 'COD',
      key: 'cod',
      width: 140,
      render: (_, r) => (
        <div>
          <div><Tag color="volcano">{r.codCount} orders</Tag></div>
          <div style={{ fontSize: 12, color: '#64748b' }}>₹ {r.codAmount.toFixed(2)}</div>
        </div>
      ),
    },
    {
      title: 'Direct',
      key: 'direct',
      width: 140,
      render: (_, r) => (
        <div>
          <div><Tag color="green">{r.directCount} orders</Tag></div>
          <div style={{ fontSize: 12, color: '#64748b' }}>₹ {r.directAmount.toFixed(2)}</div>
        </div>
      ),
    },
    {
      title: 'Total',
      key: 'total',
      width: 140,
      render: (_, r) => (
        <div>
          <div><Tag color="blue">{r.totalCount} orders</Tag></div>
          <div style={{ fontSize: 12, color: '#64748b' }}>₹ {r.totalAmount.toFixed(2)}</div>
        </div>
      ),
    },
  ]), []);

  // // Ensure each row has a unique `key`
  // const formattedOrderData = orderData.length > 0 && handleTableData(orderData).map((item) => ({
  //   ...item,
  // }));
  // const formattedAssignTableData = handleTableData(assignTableData).map((item) => ({
  //   ...item,
  //   key: item.node.id,  // Shopify order ID as unique key
  // }));

  // useEffect(() => {
  //   if (selectedRange) {
  //     setIsSelectDataRange(true)
  //     const [startDate, endDate] = selectedRange;
  //     if (activeButton == "all_orders" || activeButton == "today_orders") {
  //       let filteredData = []
  //       filteredData = formattedOrderData.filter((order) => {
  //         const orderDate = new Date(order.createdAt);
  //         return orderDate >= new Date(startDate) && orderDate <= new Date(endDate);
  //       });
  //       console.log(filteredData, "formattedOrderData");
  //       setDateRangeData(filteredData)
  //     } else {
  //       console.log(formattedAssignTableData, "formattedAssignTableData");
  //       filteredData = formattedAssignTableData.filter((order) => {
  //         const orderDate = new Date(order.createdAt);
  //         return orderDate >= new Date(startDate) && orderDate <= new Date(endDate);
  //       });
  //       setDateRangeData(filteredData)
  //     }
  //     if (!startDate || !endDate) {
  //       setIsSelectDataRange(false)
  //     }
  //   } else {
  //     setIsSelectDataRange(false)
  //   }
  // }, [selectedRange])

  return (
    <HomeContext.Provider value={passData}>
      <MainLayout>
        {!isMobile && (
          <div style={{ marginBottom: 20 }}>
            <h2 style={{ margin: 0, fontSize: 22, fontWeight: 700, color: '#0f172a', letterSpacing: '-0.02em' }}>
              Operations Overview
            </h2>
            <div style={{ fontSize: 13, color: '#64748b', marginTop: 2 }}>
              Real-time monitoring of fleet status, active assignments, and delivery volume
            </div>
          </div>
        )}
        <DashboardCards
          orders={Array.isArray(orderData) ? orderData.length : 0}
          todayOrders={Array.isArray(orderData) ? orderData.filter(order => {
            if (!order || !order.createdAt) return false;
            const today = moment().format("YYYY-MM-DD"); // Local date format
            const orderDate = moment(order.createdAt).format("YYYY-MM-DD"); // Localized order date
            return orderDate === today;
          }).length : 0}
          assignedOrders={Array.isArray(orderData) ? orderData.filter(o => (o?.shipments || []).some(s => s?.driverId)).length : 0}
          totalDrivers={Array.isArray(driverData) ? driverData.length : 0}
          onlineDrivers={Array.isArray(driverData) ? driverData.filter(driver => driver && driver.isAvailable === "Online").length : 0}
          offlineDrivers={Array.isArray(driverData) ? driverData.filter(d => d && d.isAvailable !== "Online").length : 0}
        />

        <Card
          title={<span style={{ fontWeight: 800 }}>Driver Report</span>}
          style={{ borderRadius: 12 }}
          styles={{ body: { padding: 12 } }}
        >
          <Table
            columns={driverReportColumns}
            dataSource={driverReportRows}
            size="small"
            rowKey="id"
            pagination={{ pageSize: 8, size: 'small' }}
            scroll={{ x: 'max-content' }}
            locale={{ emptyText: 'No drivers found for this store.' }}
          />
        </Card>

        <Card
          title={<span style={{ fontWeight: 800 }}>Today: Driver-wise COD vs Direct</span>}
          style={{ borderRadius: 12, marginTop: 16 }}
          styles={{ body: { padding: 12 } }}
        >
          <Row gutter={[12, 12]} style={{ marginBottom: 12 }}>
            <Col xs={24} sm={12} md={6}>
              <Card size="small" style={{ borderRadius: 10 }}>
                <Statistic title="COD Orders" value={todayDriverPaymentTotals.codCount} formatter={formatter} />
              </Card>
            </Col>
            <Col xs={24} sm={12} md={6}>
              <Card size="small" style={{ borderRadius: 10 }}>
                <Statistic title="COD Amount" value={todayDriverPaymentTotals.codAmount} formatter={(v) => <>₹ {formatter(v)}</>} />
              </Card>
            </Col>
            <Col xs={24} sm={12} md={6}>
              <Card size="small" style={{ borderRadius: 10 }}>
                <Statistic title="Direct Orders" value={todayDriverPaymentTotals.directCount} formatter={formatter} />
              </Card>
            </Col>
            <Col xs={24} sm={12} md={6}>
              <Card size="small" style={{ borderRadius: 10 }}>
                <Statistic title="Direct Amount" value={todayDriverPaymentTotals.directAmount} formatter={(v) => <>₹ {formatter(v)}</>} />
              </Card>
            </Col>
          </Row>

          <Table
            columns={todayDriverPaymentColumns}
            dataSource={todayDriverPaymentRows}
            size="small"
            rowKey="driverId"
            pagination={{ pageSize: 8, size: 'small' }}
            scroll={{ x: 'max-content' }}
            locale={{ emptyText: 'No driver assignments found for today.' }}
          />
        </Card>
      </MainLayout>
    </HomeContext.Provider >
  )
}

export default Dashboard